module.exports = __webpack_public_path__ + "img/S-WEB-Goal-10.0c433188.png";